module.exports = __webpack_public_path__ + "static/media/home9.b4582bbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/home9.svg
// module id = 3043
// module chunks = 7